import { render, staticRenderFns } from "./forbidden-keyword-filter.vue?vue&type=template&id=41b7e24c"
import script from "./forbidden-keyword-filter.vue?vue&type=script&lang=js"
export * from "./forbidden-keyword-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports